export default __webpack_public_path__ + "static/media/0009.7791165b.svg";